<h2 mat-dialog-title>End User License Agreement (EULA)</h2>

<mat-dialog-content #eulaContent class="eula-container" (scroll)="checkScroll()">

    <h3>End User License Agreement (EULA) for Paypiere</h3>

    <p><strong>Version:</strong>1.1</p>
    <p><strong>Effective Date:</strong> October 10, 2025</p>

    <p>
        This End User License Agreement (“Agreement”) is a legal agreement between you (“User” or “You”) and
        Rampiere IT Solutions (“Company,” “We,” “Us,” or “Our”). By registering for, accessing, or using Paypiere
        (the “App”) and its associated services (the “Services”), you agree to comply with and be bound by this
        Agreement.
        If you do not agree, do not complete registration or use the App.
    </p>

    <h4>1. License Grant</h4>
    <p>
        The Company grants you a limited, non-exclusive, non-transferable, and revocable license to use the App and
        Services
        solely for your personal or business use in accordance with this Agreement. You may not share your account or
        access credentials with third parties. You may not modify, distribute, resell, reverse engineer, or exploit the
        App beyond what is expressly authorized. The App and Services are licensed, not sold, and all rights not
        expressly
        granted remain with the Company.
    </p>

    <h4>2. Subscription and Payment Terms</h4>
    <h5>2.1 Subscription Plans</h5>
    <p>
        The App operates on a subscription basis. By subscribing, you agree to pay the applicable fees as stated on our
        website
        or within the App.
    </p>

    <h5>2.2 Payment Terms</h5>
    <p>
        You authorize the Company to charge your selected payment method on a recurring basis (monthly, yearly, or as
        otherwise stated).
        All fees are quoted in Philippine Pesos (PHP) and are exclusive of applicable taxes unless otherwise stated.
        Fees are
        non-refundable, except where required by law.
    </p>

    <h5>Basic Package Clause</h5>
    <p>
        The Starter package may be claimed only once per client. If payroll exceeds five (5) employees during a billing
        period,
        your subscription will automatically upgrade to the Basic package, and corresponding fees will apply.
        Subscriptions
        may only be upgraded to the next tier. Downgrades are not permitted within the same contract period.
    </p>

    <h5>2.3 Subscription Renewals & Non-Renewal</h5>
    <p>
        Subscriptions renew automatically unless canceled in accordance with our cancellation policy. If not renewed,
        you
        will have 30 days to download or export your data. After the grace period, all client data may be permanently
        deleted.
        Data retention after non-renewal is solely your responsibility.
    </p>

    <h4>3. User Responsibilities</h4>
    <p>You agree to:</p>
    <ul>
        <li>Use the App in compliance with all applicable laws and regulations.</li>
        <li>Maintain the confidentiality of your account credentials and accept responsibility for all activity under
            your account.</li>
    </ul>

    <h5>Payroll Disclaimer</h5>
    <p>
        We provide payroll computation tools only as an aid. You remain solely responsible for all payroll remittances,
        statutory filings, government submissions, and legal compliance. The Company is not liable for penalties,
        surcharges,
        fines, or damages resulting from your failure to make timely and accurate payments or filings.
    </p>

    <p>You further agree not to:</p>
    <ul>
        <li>Use the App for unlawful purposes.</li>
        <li>Interfere with or disrupt the App or Services.</li>
        <li>Reverse engineer or attempt to extract source code.</li>
    </ul>

    <h4>4. HR Services and Support</h4>
    <h5>4.1 HR Services</h5>
    <p>
        Your subscription may include HR-related functions such as employee management tools, payroll processing, and
        training resources. These are provided strictly as software tools and do not constitute legal, tax, or
        accounting advice.
    </p>

    <h5>4.2 Support</h5>
    <p>
        Support is available per your subscription plan and covers only technical and software-related issues. Support
        does
        not extend to legal, financial, or compliance consulting.
    </p>

    <h4>5. Privacy and Data Protection</h4>
    <p>
        By using the App, you consent to the collection and processing of data as outlined in our Privacy Policy. We
        comply
        with Republic Act No. 10173 (Data Privacy Act of 2012) and maintain organizational, technical, and physical
        safeguards
        to protect your personal and sensitive information. Your rights as a data subject (access, correction, erasure,
        and objection)
        are respected and upheld. Data may be hosted on secure servers within or outside the Philippines under
        equivalent security safeguards.
    </p>

    <h4>6. Term and Termination</h4>
    <h5>6.1 Term</h5>
    <p>This Agreement remains in effect as long as you use the App or until terminated.</p>

    <h5>6.2 Termination</h5>
    <p>
        You may terminate by canceling your subscription. We may terminate immediately if you breach this Agreement,
        misuse
        the App, or if required by law. The Company may also discontinue the Services with 30 days’ notice for business
        or technical reasons. Upon termination, you must cease all use of the App. No refunds will be issued unless
        required by law.
    </p>

    <h4>7. Limitation of Liability</h4>
    <p>
        To the maximum extent permitted by law: Our liability is capped at the fees paid by you in the three (3) months
        immediately
        preceding the claim, or ₱25,000, whichever is lower. We are not liable for indirect, incidental, special,
        consequential,
        or punitive damages.
    </p>

    <h4>8. Indemnification</h4>
    <p>
        You agree to indemnify and hold harmless the Company, its officers, employees, and affiliates against any
        claims, damages,
        or expenses arising from your breach of this Agreement, misuse of the App, or failure to comply with legal
        obligations.
    </p>

    <h4>9. Modifications to Agreement</h4>
    <p>
        We may update this Agreement at any time. Material changes will be communicated at least 15 days in advance.
        Continued
        use after changes constitutes acceptance.
    </p>

    <h4>10. Governing Law and Dispute Resolution</h4>
    <p>This Agreement is governed by the laws of the Republic of the Philippines. Any disputes shall be subject to the
        exclusive jurisdiction of courts in Metro Manila.</p>

    <h4>11. Miscellaneous</h4>
    <h5>11.1 Severability</h5>
    <p>If any provision is invalid, the remainder remains enforceable.</p>

    <h5>11.2 Entire Agreement</h5>
    <p>This Agreement is the entire understanding between you and the Company and supersedes prior agreements.</p>

    <h5>11.3 Force Majeure</h5>
    <p>
        We are not responsible for delays or failures due to causes beyond our reasonable control, including natural
        disasters,
        power outages, internet failures, government actions, or pandemics.
    </p>

    <h4>12. Compliance and Data Retention</h4>
    <p>
        Active and inactive employee records are retained only while the subscription is active. Upon termination or
        expiration,
        data will be retained only in accordance with Philippine laws (e.g., BIR and labor regulations). After required
        retention periods,
        data will be securely deleted unless a longer period is legally required.
    </p>

    <p>
        I have read and agree to the End User License Agreement (EULA) and Privacy Policy of Paypiere.
    </p>

    <div class="row d-flex align-items-center justify-content-center">
        <button mat-button class="btn btn-success px-5" (click)="confirm()" [disabled]="!scrolledToBottom">I
            Agree</button>
    </div>

</mat-dialog-content>